import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../base-dialog';

export const DeleteDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isPending,
  title,
  description,
  confirmLabel,
  cancelLabel,
  'data-testid': dataTestId,
  confirmButtonTestId,
  cancelButtonTestId,
}: {
  open: boolean;
  onOpenChange: (isDialogOpen: boolean) => void;
  onConfirm: () => void | Promise<void>;
  isPending?: boolean;
  title: string;
  description: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  'data-testid'?: string;
  confirmButtonTestId?: string;
  cancelButtonTestId?: string;
}) => {
  const { t } = useTranslation();

  return (
    <BaseDialog
      data-testid={dataTestId}
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      intent="destructive"
      size="sm"
      isPending={isPending}
      primaryAction={{
        label: confirmLabel ?? t(($) => $.common.delete),
        onClick: onConfirm,
        'data-testid': confirmButtonTestId,
      }}
      secondaryAction={{
        label: cancelLabel ?? t(($) => $.common.cancel),
        onClick: () => onOpenChange(false),
        'data-testid': cancelButtonTestId,
      }}
    />
  );
};
